module.exports = __webpack_public_path__ + "img/image02.41468414.jpg";